import Axios from '../api/axios';
import * as glb from '../globals.js';
import { getSelectableUsers } from './userLookup';
import { dispatchLookupUpdated, persistLookupCache } from './lookupStorage';

export const KULLANICI_LKP_EVENT = 'kullaniciLkpUpdated';

export function applyGlobalKullaniciLkp(users) {
    glb.default.KULLANICILkp = Array.isArray(users) ? users : [];
    glb.default.KULLANICISECIMLkp = getSelectableUsers(glb.default.KULLANICILkp);
    persistLookupCache('KULLANICILkp', glb.default.KULLANICILkp);
    persistLookupCache('KULLANICISECIMLkp', glb.default.KULLANICISECIMLkp);
    dispatchLookupUpdated(KULLANICI_LKP_EVENT, { count: glb.default.KULLANICILkp.length });
}

export function refreshGlobalKullaniciLkp() {
    return Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}doalls/lkp?ptype=user`)
        .then((res) => {
            applyGlobalKullaniciLkp(res.data);
        });
}
